export const expensesEs = {
  upload_expenses: "Subir gastos",
  upload_success: "Subido exitosamente",
  download_expenses: "Descargar gasto",
  expenses: "Gastos",
  expense_management: "Gestión de gastos",
  expense_upload_title: "Carga de gastos",
  instructions_description:
    "Suelta el CSV aquí o haz clic para buscar en tu máquina.",
  upload_file: "Subir",
  confirm_upload_message: "¿Estás seguro de que quieres subir este CSV?",
  employee_required: "El empleado es requerido",
  csv_format_allowed: "El formato CSV no es válido",
  csv_notvalid: "CSV inválido",
  download_file: "Descargar archivo",
  in_process: "En proceso",
  processed: "Procesado",
  failed: "Fallido",
  file_name: "Nombre del archivo",
  uploaded_on: "Subido el",
  uploaded_by: "Subido por",
  status: "Estado",
  actions: "Acciones",
  no: "No",
  yes: "Sí",
  receipt_number: "Número de recibo",
  expense_date: "Fecha de gasto",
  vendor: "Proveedor",
  currency: "Moneda",
  total_amount: "Monto total",
  total_tax: "Impuesto total",
  payment_status: "Estado de pago",
  created_by: "Creado por",
  delete: "Eliminar",
  deleting: "Eliminando",
  edit: "Editar",
  view_receipt_details: "Ver detalles del recibo",
  paid: "Pagado",
  partially_paid: "Parcialmente pagado",
  overdue: "Vencido",
  pending: "Pendiente",
  view: `Ver`,
  view_expense_details: `Ver detalles del gasto`,
  expense_items: `Artículos del gasto`,
  total_summary: `Resumen total`,
  created_info: `Información de creación`,
  completed_on: `Completado el`,
  download_success: `Descargado exitosamente`,
  category: `Categoría`,
  employee_notfound: `Empleado no encontrado`,

  // expense category
  expense_category: `Categoría de gasto`,
  id: `ID`,
  category_name: `Nombre de la categoría`,
  add_category: `Agregar categoría`,
  add_expense_category: `Agregar categoría de gasto`,
  placeholder_category_name: `Ingrese el nombre de la categoría`,
  expense_category_exists: `La categoría de gasto ya existe`,
  category_name_required: `El nombre de la categoría es obligatorio`,
  category_name_min: `El nombre de la categoría debe tener al menos 3 caracteres`,
  category_name_max: `El nombre de la categoría no debe superar los 50 caracteres`,
  category_name_only_alphabets: `Solo se permiten letras y espacios`,
  category_created_success: `Categoría creada exitosamente`,
  no_permission: `No tienes permiso para la categoría de gasto`,
  edit_expense_category: "Editar Categoría de Gasto",
  category_updated_success: "Categoría actualizada exitosamente",
  successfully_deleted: "Eliminado exitosamente",
  delete_failed: "Error al eliminar",
  delete_category_dialog: "Eliminar Categoría",
  expensecategoty_not_found: "Categoría de gasto no encontrada",
  expense: `Gasto`,
  upload_request: `Solicitud de carga`,
  category_setup: `Configuración de categoría`,
};
